/**
 * Centralized, typesafe registry of all keyboard shortcuts.
 *
 * Each key is a unique shortcut identifier and the value contains
 * the tinykeys binding(s). Use `SHORTCUTS["toggle-sidebar"].shortcut`
 * when registering actions or rendering shortcut badges.
 */
export const SHORTCUTS = {
  "command-palette": { shortcut: ["$mod+k"] },
  "toggle-sidebar": { shortcut: ["$mod+b"] },
  "go-home": { shortcut: ["g h"] },
  "go-boards": { shortcut: ["g b"] },
  "go-datasets": { shortcut: ["g d"] },
  "browse-datasets": { shortcut: ["g c"] },
  "go-datasources": { shortcut: ["g o"] },
  "go-knowledge": { shortcut: ["g k"] },
  "go-settings": { shortcut: ["g s"] },
  "go-plans": { shortcut: ["g p"] },
  "run-query": { shortcut: ["$mod+Enter"] },
  "change-theme": { shortcut: ["$mod+Shift+l"] },
  "toggle-left-pane": { shortcut: ["$mod+ArrowLeft"] },
  "toggle-bottom-pane": { shortcut: ["$mod+j"] },
  "toggle-right-pane": { shortcut: ["$mod+/"] },
  "save-dataset": { shortcut: ["$mod+s"] },
  "cycle-chat-mode": { shortcut: ["Shift+Tab"] },
  // Datasets browse page. Bare letters are safe here because these actions are
  // route-scoped and `ShortcutBinder` ignores unmodified keys while focus is in
  // an input. Avoid any letter used as the tail of a `g <key>` chord above — a
  // standalone binding matches regardless of what preceded it.
  "new-dataset": { shortcut: ["n"] },
  "new-dataset-folder": { shortcut: ["f"] },
  "search-datasets": { shortcut: ["/"] },
} as const satisfies Record<string, { shortcut: string[] }>;

/** Union of all registered shortcut identifiers. */
export type ShortcutId = keyof typeof SHORTCUTS;
